import * as Sentry from "@sentry/react";

/**
 * Inicialização global do Sentry para TicketHall (Vite + React SPA)
 */
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    if (import.meta.env.DEV) {
      console.info("[Sentry] VITE_SENTRY_DSN não configurado. Monitoramento externo inativo.");
    }
    return;
  }

  Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance & Tracing
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    // Supabase REST/Auth/Storage e Asaas não recebem tracing do nosso backend.
    // Propagar headers para esses serviços só adicionava preflights e bloqueios
    // de CORS. O tracing do navegador e a captura de erros continuam ativos.
    tracePropagationTargets: [],

    // Session Replay (vídeo do que o usuário fez)
    replaysSessionSampleRate: 0.1, // 10% das sessões comuns
    replaysOnErrorSampleRate: 1.0, // 100% das sessões com erro gravadas!

    environment: import.meta.env.MODE,
    release: (window).__TICKETHALL_BUILD__?.commit || "dev",
  });

  if (typeof window !== "undefined") {
    (window).__triggerSentryTest = () => {
      const testErr = new Error("TicketHall Sentry Verification Test");
      Sentry.captureException(testErr);
      console.log("🚨 Evento de teste enviado para o Sentry com sucesso!");
    };
  }
}

/**
 * Associa o usuário logado aos erros capturados pelo Sentry
 */
export function setSentryUser(user: { id?: string; email?: string | null; role?: string | null } | null) {
  if (!user) {
    Sentry.setUser(null);
    return;
  }
  Sentry.setUser({
    id: user.id,
    email: user.email || undefined,
    username: user.email || undefined,
    segment: user.role || undefined,
  });
}

/**
 * Envia um erro manualmente para o Sentry com dados de contexto adicionais
 */
export function captureException(error: unknown, context?: Record<string, unknown>) {
  if (context) {
    Sentry.captureException(error, { extra: context });
  } else {
    Sentry.captureException(error);
  }
}

export { Sentry };
